var app = angular.module("leonardo");

var TemplateForm = function(
  $scope,
  $controller,
  $state,
  $q,
  $timeout,
  templateObj,
  TemplateService,
  FilterService,
  FormErrorsService,
  FieldSubgroupService,
  AccountUserService,
  AccountService,
  CategoryRestService,
  AuthDataService,
  SubCategoryRestService,
  CategoryVendorService,
  AnalyticsService
) {

  $scope.onboarding = $state.current.onboarding ? true : false;
  $scope.template = templateObj;
  $scope.tabsCollapsed = [];
  $scope.mode = 'template';
  $scope.action = $state.current.action;
  $scope.origin = $state.params.origin;
  $scope.categoryOptions = [];
  $scope.roleOptions = [];
  $scope.subcategoryOptions = [];
  $scope.vendorCategoryOptions = [];

  $scope.accountUsers = [];
  $controller('TemplateBaseForm', { $scope: $scope });

  $scope.account = AccountUserService.currentAccountUser.account;
  $scope.accountUser = AccountUserService.getAccountUser($scope.account);

  $scope.setRoleOptions = function(roles) {
    $scope.roleOptions = roles;
  };

  $scope.setCategories = function(categories) {
    $scope.categoryOptions = categories;
  };

  $scope.setSubcategories = function(subcategories) {
    $scope.subcategoryOptions = subcategories;
  };

  $scope.setVendorCategories = function(vendorCategories) {
    $scope.vendorCategoryOptions = vendorCategories;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      $scope.getErrors();
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
       if ($scope.action === 'create') {
      var templateType = $scope.getTemplateType();
      var all = [];
      switch (templateType) {
        case 'property':
          data['type'] = TemplateService.TYPE_PROPERTY;
          data['property'] = FilterService.getFilter('property');
          break;
        case 'account':
          data['type'] = TemplateService.TYPE_ACCOUNT;
          break;
        case 'portfolio':
          data['type'] = TemplateService.TYPE_PORTFOLIO;
          break;
        case 'owner':
          data['type'] = TemplateService.TYPE_ACCOUNT_USER;
          break;
        case 'system':
          data['type'] = TemplateService.TYPE_SYSTEM;
          break;
        case 'trigger':
          data['type'] = TemplateService.TYPE_TRIGGER;
          break;
      }
      
      let selectedCategory = $scope.categoryOptions.find(c => c.id == data.category);
      let selectedSubcategory = $scope.subcategoryOptions.find(s => s.id == data.subcategory);
      let selectedRoles = $scope.roleOptions.filter(r => data.roles && data.roles.includes(r.id));
      let selectedVendorCategories = $scope.vendorCategoryOptions.filter(v => v.id == data.vendor_category);
      
      if (templateType === 'portfolio') {
        all = [];
        if($state.params.portfolios) {
          angular.forEach($state.params.portfolios.split(','), function(portfolio) {
            var templateData = angular.copy(data);
            templateData['portfolio'] = portfolio;
            all.push(TemplateService.post(templateData, true).then(function(response) {
              AnalyticsService.track('Task Added', {
                ...AnalyticsService.getTaskGroupProperties(response),
                ...AnalyticsService.getTaskDetailsProperties(response, selectedCategory, selectedSubcategory, selectedRoles, selectedVendorCategories),
                template_id: response.id,
                task_id: null
              })
              return response;
            }));
          });
        }
        if($state.params.properties) {
          angular.forEach($state.params.properties.split(','), function(property) {
            var templateData = angular.copy(data);
            templateData['type'] = TemplateService.TYPE_PROPERTY;
            templateData['property'] = property;
            all.push(TemplateService.post(templateData, true).then(function(response) {
              AnalyticsService.track('Task Added', {
                ...AnalyticsService.getTaskGroupProperties(response),
                ...AnalyticsService.getTaskDetailsProperties(response, selectedCategory, selectedSubcategory, selectedRoles, selectedVendorCategories),
                template_id: response.id,
                task_id: null
              })
              return response;
            }));
          });
        }
        $q.all(all).then(function () {
          $scope.redirect();
        });
      }
      else {
        TemplateService.post(data).then(function (response) {
          AnalyticsService.track('Task Added', {
            ...AnalyticsService.getTaskGroupProperties(response),
            ...AnalyticsService.getTaskDetailsProperties(response, selectedCategory, selectedSubcategory, selectedRoles, selectedVendorCategories),
            template_id: response.id,
            task_id: null
          })
          return response;
        }).then(function () {
          $scope.redirect();
        });
      }
    }
    else {
      templateObj.patch(data).then(function () {
        $scope.redirect();
      });
    }
  };

  $scope.redirect = function() {
    if ($scope.onboarding) {
      $state.go('onboarding');
      return;
    }
    switch ($scope.templateMode) {
      case 'property':
        if($state.params.origin === 'task')
          $state.go('property.tasks');
        else
          $state.go('property.templates');

        return;
      case 'template':
        $state.go('templates');
        return;
      case 'owner':
        $state.go('owner-tasks.templates');
        return;
    }
  };

  $scope.$on('template:created', function() {
    $scope.redirect();
  });

  $scope.initParams();

  FieldSubgroupService.getlist({
    disable_pagination: true,
    sector: $scope.authDataService.authData.account ? $scope.authDataService.authData.account.sector : ''
  }).then(function(data){
    $scope.fieldSubgroups = data;
    $scope.overridableInitParams();
  });
};

app.controller('TemplateForm', [
  '$scope',
  '$controller',
  '$state',
  '$q',
  '$timeout',
  'templateObj',
  'TemplateService',
  'FilterService',
  'FormErrorsService',
  'FieldSubgroupService',
  'AccountUserService',
  'AccountService',
  'CategoryRestService',
  'AuthDataService',
  'SubCategoryRestService',
  'CategoryVendorService',
  'AnalyticsService',
  TemplateForm
]);
